import 'assets/css/HAGD-Custom.css';
import React, {useEffect} from 'react';
// import {useSelector} from 'react-redux';
// import {useState} from 'react';
// import DNS from 'components/DNS/dns.js';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
// import {DateRange} from 'react-date-range';
// import Moment from 'react-moment';
import 'assets/css/commentaireOverview.css';
import {isMobile} from 'react-device-detect';

// react-bootstrap components
import {
//   Button,
//   Card,
//   Modal,
//   Form,
//   Table,
  Container,
//   Row,
//   Col,
} from 'react-bootstrap';
// import {fr} from 'react-date-range/dist/locale';

/**
 * This function handle all the event and style in the colis page.
 * @function Colis
 * @return {HTML} the colis's page.
 */
const FoodlesWebview = () => {
  //   const token = useSelector((state) => state.token);
  //   const currentBuilding = useSelector((state) => state.currentBuilding);
  //   const [showModal, setShowModal] = React.useState(false);
  //   const [showRecipient, setRecipient] = useState('');
  //   const [showHour, setHour] = useState('');
  //   const [showDate, setDate] = useState('');
  //   const [showSender, setSender] = useState('');
  //   const [showCompany, setCompany] = useState('');
  //   const [searchTerm, setSearchTerm] = useState('');
  //   const [showDisplayDateRange, setDisplayDateRange] = useState('none');
  //   const [state, setState] = useState([
  //     {
  //       startDate: new Date(),
  //       endDate: new Date(),
  //       key: 'selection',
  //     },
  //   ]);
  //   const [alist, setList] = useState({
  //     data: null,
  //     error: false,
  //   }, []);
  //   const requestOptions = {
  //     method: 'GET',
  //     headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + token['tokenRedux']},
  //   };
  useEffect(() => {
    // getParcel();
  }, []);


  return (
    isMobile ?
      <div style={{background: 'white', height: 1000, width: window.innerWidth}}>
        <iframe sandbox="allow-same-origin allow-scripts" style={{height: '100%', width: window.innerWidth}} src="https://app.foodles.co/signin-or-signup"></iframe>
      </div> :
    <Container fluid>
      <div style={{background: 'white', height: window.innerHeight, width: window.innerWidth / (2.5), marginLeft: '30%'}}>
        <iframe sandbox="allow-same-origin allow-scripts" style={{height: '100%', width: '100%'}} src="https://app.foodles.co/signin-or-signup"></iframe>
      </div>
    </Container>
  );
};

export default FoodlesWebview;
